/* eslint-disable jsx-a11y/anchor-is-valid */

import React from "react";
import CaseStudiesChildFooter from "./CaseStudiesChildFooter";
import ic_chat_big_circle from "../../assets/images/pictures/icon/ic_outline-question_answer_big_circle-64px.svg";
import ic_paper_circle from "../../assets/images/pictures/icon/ic_paper_circle.svg";
import ic_assignment_circle from "../../assets/images/pictures/icon/ic_outline-assignment_circle-40px.svg";
import ic_return_assignment_circle from "../../assets/images/pictures/icon/ic_outline-assignment_return_circle-40px.svg";
import ic_list_all_circle from "../../assets/images/pictures/icon/ic_outline-list_circle-40px.svg";
import ic_menu_circle from "../../assets/images/pictures/icon/ic_outline-menu_circle-40px.svg";
import ic_assessment_circle from "../../assets/images/pictures/icon/ic_outline-assessment_circle-40px.svg";
import { motion } from "framer-motion";
import routeVariants from "../../assets/animates/routeVariants";
import { useTranslation } from "react-i18next";
import Footer from "../../components/global/Footer";
import NavbarBottom from "../../components/global/NavbarBottom";
import list from "../../assets/images/logos/case/doclist.png";
import cover from "../../assets/images/logos/case/cover.png";

const CaseStudiesCSContent = () => {
  const { t } = useTranslation();

  return (
    <motion.div
      variants={routeVariants}
      initial="initial"
      animate="final"
      id="content"
      className="fs-navigation-overlay-content fs-navigation-overlay-left-content fs-navigation__0 no-transform"
    >
      <div className="procurement">
        <div className="container">
          <div className="row">
            <div className="col-xs-12 col-sm-10 col-sm-offset-1 header">
              <img
                className="header__ic"
                src={ic_chat_big_circle}
                alt=""
                data-no-retina=""
              />
              <h2>
                {t(
                  "case-studies-cs-page.case-studies-cs-page-content.content-1.heading"
                )}
              </h2>
              <p>
                {t(
                  "case-studies-cs-page.case-studies-cs-page-content.content-1.description"
                )}
              </p>
            </div>
            <div className="col-xs-12">
              <img
                className="img-responsive"
                src={list}
                alt="Example of GoPaperless document list"
              />
            </div>
          </div>
          <div className="row stages">
            <div className="col-xs-12 col-sm-8 col-sm-offset-2">
              <h2>
                {t(
                  "case-studies-cs-page.case-studies-cs-page-content.content-2.heading"
                )}
              </h2>
            </div>
            <div className="col-xs-12 col-sm-10 col-sm-offset-1 mb-10">
              <p>
                {t(
                  "case-studies-cs-page.case-studies-cs-page-content.content-2.description"
                )}
              </p>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-6 col-sm-offset-3 stage-cycle">
              <div className="col-sm-4">
                <img src={ic_paper_circle} alt="" data-no-retina="" />
                <p>
                  {t(
                    "case-studies-cs-page.case-studies-cs-page-content.content-2.item-1"
                  )}
                </p>
              </div>
              <div className="col-sm-4">
                <img src={ic_assignment_circle} alt="" data-no-retina="" />
                <p>
                  {t(
                    "case-studies-cs-page.case-studies-cs-page-content.content-2.item-2"
                  )}
                </p>
              </div>
              <div className="col-sm-4">
                <img
                  src={ic_return_assignment_circle}
                  alt=""
                  data-no-retina=""
                />
                <p>
                  {t(
                    "case-studies-cs-page.case-studies-cs-page-content.content-2.item-3"
                  )}
                </p>
              </div>
              <div className="col-sm-4">
                <img src={ic_list_all_circle} alt="" data-no-retina="" />
                <p>
                  {t(
                    "case-studies-cs-page.case-studies-cs-page-content.content-2.item-4"
                  )}
                </p>
              </div>
              <div className="col-sm-4">
                <img src={ic_menu_circle} alt="" data-no-retina="" />
                <p>
                  {t(
                    "case-studies-cs-page.case-studies-cs-page-content.content-2.item-5"
                  )}
                </p>
              </div>
              <div className="col-sm-4">
                <img src={ic_assessment_circle} alt="" data-no-retina="" />
                <p>
                  {t(
                    "case-studies-cs-page.case-studies-cs-page-content.content-2.item-6"
                  )}
                </p>
              </div>
            </div>
          </div>
          <div className="row about-pro">
            <div className="col-sm-5 pl-md-0">
              <img
                className="img-responsive"
                src={cover}
                alt="Thumbnail pages of Customer Service Teams and GoPaperless: A White Paper"
              />
            </div>
            <div className="col-sm-7">
              <h2>
                {t(
                  "case-studies-cs-page.case-studies-cs-page-content.content-3.heading"
                )}
              </h2>
              <p>
                {t(
                  "case-studies-cs-page.case-studies-cs-page-content.content-3.description-1"
                )}
              </p>
              <p>
                {t(
                  "case-studies-cs-page.case-studies-cs-page-content.content-3.description-2"
                )}
              </p>
              {/* <a
                className="btn-secondary"
                href="javascript:;"
                data-toggle="modal"
                data-target="#download-book"
              >
                {t(
                  "case-studies-cs-page.case-studies-cs-page-content.content-3.button-access"
                )}
              </a> */}
            </div>
          </div>
        </div>
        <CaseStudiesChildFooter />
      </div>
      <Footer />
      <NavbarBottom />
    </motion.div>
  );
};

export default CaseStudiesCSContent;
